import React from "react";
import mailIcon from "../assets/images/svgs/other/mail.svg";
import webIcon from "../assets/images/svgs/other/web.svg";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <section className="flex justify-center py-10 px-4">
      <DecorativeSquares />

      <div className="container flex flex-col items-center">
        {/* Header */}
        <div className="relative flex items-center w-full max-w-4xl h-10 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-0 flex items-center"
          >
            <FaArrowLeft className="text-lg" />
          </button>

          <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
            Privacy Policy
          </h1>
        </div>

        {/* CONTENT */}
        <div className="w-11/12 sm:w-10/12 md:w-5/6 lg:w-4/5 xl:w-3/4 space-y-10">
          {/* Intro */}
          <div className="space-y-4">
            <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
              This Privacy Policy explains how <strong>TiffinTap</strong> (“we,”
              “our,” or “us”) collects, uses, and protects your personal
              information when you use our website (tiffintap.com) and
              mobile/web applications (the “Services”).
            </p>

            <p className="text-[#191919] text-sm sm:text-base md:text-lg leading-6 sm:leading-7 md:leading-8 tracking-wide">
              By accessing or using our Services, you agree to this Privacy
              Policy.
            </p>
          </div>

          {/* 1 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              1. Information We Collect
            </h2>

            <div className="space-y-6">
              <ul className="list-disc pl-5 space-y-3 text-sm sm:text-base md:text-lg text-[#191919]">
                <li className="list-none font-semibold">
                  1.1 Personal Information You Provide
                </li>
                <li>
                  Account Details: Name, phone number, email address, profile
                  photo, and login credentials..
                </li>
                <li>
                  Service Details (for Providers): Tiffin service name,
                  description, cuisine information, pricing, addresses, delivery
                  preferences, payment collection.
                </li>
                <li>
                  Order Details (for Customers): Order history, chosen cuisine,
                  pickup/delivery details, payment notes.
                </li>
              </ul>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li className="list-none font-semibold">
                  1.2 Automatically Collected Information
                </li>
                <li>
                  Device and browser type, IP address, operating system, time
                  zone.
                </li>
                <li>
                  Usage activity such as pages visited, clicks, search terms.
                </li>
                <li> Cookies and tracking technologies (see Section 6).</li>
              </ul>

              <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
                <li className="list-none font-semibold">
                  1.3 Communication Data
                </li>
                <li>
                  {" "}
                  Records of communication via email, WhatsApp, or SMS
                  notifications.
                </li>
              </ul>
            </div>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              2. How We Use Your Information
            </h2>

            <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
              <li>Provide and improve our services.</li>
              <li>
                Allow tiffin providers to manage orders, menus, and payments.
              </li>
              <li>
                Allow customers to view menus, place orders, and track history.
              </li>
              <li>
                Send service-related communications (order confirmations,
                payment reminders, etc.).
              </li>
              <li>Analyse usage and improve performance.</li>
              <li>Comply with legal obligations.</li>
            </ul>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              3. Sharing Your Information
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              We do not sell your personal data. We may share information only
              with:
            </p>

            <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
              <li>
                Service Providers: Hosting, payment gateways (e.g., PayPal),
                analytics providers (e.g., Google Analytics), notification
                services (e.g., WhatsApp Business API).
              </li>
              <li>
                Legal Authorities: To comply with applicable law, regulations,
                or government requests.
              </li>
              <li>
                Business Transfers: In the event of a merger, acquisition, or
                sale of assets.
              </li>
            </ul>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              4. International Data Transfers
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              Your information may be stored on servers outside your country
              (including AWS India). By using our Services, you consent to such
              transfers, subject to adequate safeguards under GDPR, CCPA,
              PIPEDA, and other regional laws.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              5. Your Rights
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              Depending on your region, you may have the following rights:
            </p>

            <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
              <li>
                GDPR (EU/UK): Right to access, correct, erase, restrict
                processing, data portability, and object.
              </li>
              <li>
                CCPA (California): Right to know, right to delete, right to
                opt out of data selling (we do not sell), right to
                non-discrimination.
              </li>
              <li>
                PIPEDA (Canada): Right to access and correct personal
                information.
              </li>
              <li>
                Australia: Rights under the Privacy Act to access and correct
                personal information.
              </li>
              <li>
                To exercise rights, email us at{" "}
                <a
                  href="mailto:privacy@tiffintap.com"
                  className="text-[#FF6943] underline"
                >
                  privacy@tiffintap.com
                </a>
              </li>
            </ul>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              6. Cookies & Analytics
            </h2>

            <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base md:text-lg text-[#191919]">
              <li>
                Cookies: We use cookies to remember login sessions, save
                preferences, and improve user experience.
              </li>
              <li>
                Analytics: We use Google Analytics and similar tools. You can
                opt out at Google Opt-Out Tool.
              </li>
              <li>
                Advertising Cookies: In future, we may use Google AdX/AdSense
                for customer-facing portals. You can opt out via DAA Opt-Out.
              </li>
            </ul>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              7. Children’s Privacy
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              Our Services are not directed to children under 13 years old. We
              do not knowingly collect information from children under 13. If we
              learn we have collected personal information from a child under
              13, we will delete it.
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              8. Retention of Data
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              We retain your data as long as your account is active or as
              required to provide services. Data may be retained longer if
              necessary to comply with legal obligations.
            </p>
          </section>

          {/* 9 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              9. Security
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              We use encryption, access controls, and secure hosting to protect
              your data. However, no system is 100% secure.
            </p>
          </section>

          {/* 10 */}
          <section>
            <h2 className="text-lg md:text-xl font-bold text-black mb-4">
              10. Changes to This Policy
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-[#191919] leading-7">
              We may update this Privacy Policy periodically. Changes will be
              effective when posted on{" "}
              <a href="#" className="text-[#FF6943] underline">
                tiffintap.com
              </a>
              .
            </p>
          </section> 

          <section>
            <h3 className="font-bold text-md md:text-lg mb-2">
              11. Contact Us
            </h3>
            <ul className="list-disc pl-5 text-sm sm:text-base md:text-lg text-[#191919] space-y-3">
              <li>For questions or privacy requests, contact us at:</li>

              <li className="flex items-center gap-2 list-none">
                <img
                  src={mailIcon}
                  alt="email_icon"
                  className="w-4 h-4 md:w-5 md:h-5"
                />
                <a
                  href="mailto:hello@webapprise.com"
                  className="text-[#FF6943] underline hover:text-[#ff4d1c] transition-colors"
                >
                  hello@webapprise.com
                </a>
              </li>

              <li className="flex items-center gap-2 list-none">
                <img
                  src={webIcon}
                  alt="web_icon"
                  className="w-4 h-4 md:w-5 md:h-5"
                />
                <a
                  href="https://www.tiffintap.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#FF6943] underline hover:text-[#ff4d1c] transition-colors"
                >
                  www.tiffintap.com
                </a>
              </li>
            </ul>
          </section>

          <section>
            <p className="text-sm sm:text-base md:text-lg text-[#191919]">
              If you are in the EU/UK and not satisfied with our response, you
              may lodge a complaint with your local Data Protection Authority
              (DPA).
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
